export default __webpack_public_path__ + "static/media/btn_rt_arrow.9fe2918f.svg";